export const getCarTypeKey = 'getCarType';
export const getCarMarkKey = 'getCarMark';
export const getCarModelKey = 'getCarModel';
export const getCarGenerationKey = 'getCarGeneration';
export const getCarBodyTypeKey = 'getCarBodyType';
export const getCarModificationKey = 'getCarModification';
export const getCarCharacteristicKey = 'getCarCharacteristic';
